import { checkIfValueNotEmpty } from 'legacy/lut/helpers/checkIfValueNotEmpty'
import { checkPhone } from 'legacy/lut/helpers/validateRules/checkPhone'
import React from 'react'

import { useGetFormData } from 'cng-common/features/form'
import { isValidEmail } from 'core-components/library/validation'
import { MY_CONNECT_TYPE } from 'dialer/classes/models/MyConnectType'
import {
  CALL_MODE,
  CallablePhoneWrapper,
  getFullPhone,
} from 'dialer/components/widgets/public/callPhoneWrapper/CallablePhoneWrapper'
import { OnboardingFormInput } from 'onboarding/components/ui/theme'
import { OnboardingFormPhoneEditor } from 'onboarding/components/ui/theme/OnboardingFormPhoneEditor'
import { LNR_CHAMPION_FORM_KEY } from 'onboarding/components/widgets/public/forms/configs'
import { TLNRChampion } from 'onboarding/components/widgets/public/forms/lnr/models'

import styles from './LNRData.module.scss'

interface IProps {
  formKey: string
  firstName: string
  lastName: string
  email: string
  jobTitle: string
  workPhonePrefix: string
  workPhone: string
  mobilePhonePrefix: string
  mobilePhone: string
  isDisabled: boolean
  callablePhoneAdditionalAttributes?: Record<string, any>
}

export const FormFields = ({
  formKey,
  firstName,
  lastName,
  email,
  jobTitle,
  workPhonePrefix,
  workPhone,
  mobilePhonePrefix,
  mobilePhone,
  isDisabled,
  callablePhoneAdditionalAttributes,
}: IProps) => {
  const [{ formData }] = useGetFormData<TLNRChampion>(LNR_CHAMPION_FORM_KEY)

  return (
    <div>
      <div className={styles.wrapper}>
        <OnboardingFormInput
          defaultValue={firstName}
          label={'First Name'}
          field={'FirstName'}
          formKey={formKey}
          isRequired={true}
          isDisabled={isDisabled}
        />
      </div>

      <div className={styles.wrapper}>
        <OnboardingFormInput
          defaultValue={lastName}
          label={'Last Name'}
          field={'LastName'}
          formKey={formKey}
          isRequired={true}
          isDisabled={isDisabled}
        />
      </div>

      <div className={styles.wrapper}>
        <OnboardingFormInput
          defaultValue={email}
          label={'Email'}
          field={'Email'}
          formKey={formKey}
          onValidate={isValidEmail}
          isDisabled={isDisabled}
        />
      </div>

      <div className={styles.wrapper}>
        <OnboardingFormInput
          defaultValue={jobTitle}
          label={'Job Title'}
          field={'JobTitle'}
          formKey={formKey}
          isRequired={true}
          isDisabled={isDisabled}
        />
      </div>

      <div className={styles.wrapper}>
        <CallablePhoneWrapper
          callMode={CALL_MODE.byIcon}
          phone={getFullPhone(formData?.WorkPhone_Prefix || '', formData?.WorkPhone || '')}
          type={MY_CONNECT_TYPE.Partner}
          additionalAttributes={callablePhoneAdditionalAttributes}
        >
          <OnboardingFormPhoneEditor
            formKey={formKey}
            isDisabled={isDisabled}
            label={'Work Phone'}
            phoneCodeFieldName={'WorkPhone_Prefix'}
            phoneCodeValue={workPhonePrefix}
            phoneNumberFieldName={'WorkPhone'}
            phoneNumberValue={workPhone}
            onPhoneNumberValidate={checkPhone}
            isRequired={true}
          />
        </CallablePhoneWrapper>
      </div>

      <CallablePhoneWrapper
        callMode={CALL_MODE.byIcon}
        phone={getFullPhone(formData?.MobilePhone_Prefix, formData?.MobilePhone || '')}
        type={MY_CONNECT_TYPE.Partner}
        additionalAttributes={callablePhoneAdditionalAttributes}
      >
        <OnboardingFormPhoneEditor
          formKey={formKey}
          isDisabled={isDisabled}
          label={'Mobile Phone'}
          phoneCodeFieldName={'MobilePhone_Prefix'}
          phoneCodeValue={mobilePhonePrefix}
          phoneNumberFieldName={'MobilePhone'}
          phoneNumberValue={mobilePhone}
          onPhoneNumberValidate={checkIfValueNotEmpty(checkPhone, false)}
          isRequired={false}
        />
      </CallablePhoneWrapper>
    </div>
  )
}
